<template>
  <b-card>
    <b-textarea
      class="editor"
      v-model="componentData.value"
      rows="5"
    />
  </b-card>
</template>

<script>

export default {
  name: 'TextMeshPro',
  props: {
    componentData: { type: Object, required: true },
  },
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>
